import { computed } from 'vue'
import { useMe } from '@/queries/me'
import { useMessagingOrganization } from '@/queries/messages/organization'

const useInboxLiteAccess = () => {
    const { data: me, hasFeature } = useMe()

    const hasMessagingFeatures = computed(
        () =>
            !!me.value &&
            hasFeature(`vue-2way-messaging`) &&
            hasFeature(`messaging_integration`) &&
            hasFeature(`msg-inbox-lite`)
    )

    const { data: messagingOrg } = useMessagingOrganization(hasMessagingFeatures)

    const smsMessagingEnabled = computed(
        () => Boolean(messagingOrg.value?.messaging_enabled) && Boolean(messagingOrg.value?.channels?.sms?.enabled)
    )
    const hasInboxLiteAccess = computed(() => hasMessagingFeatures.value && smsMessagingEnabled.value)

    return { hasInboxLiteAccess }
}

export default useInboxLiteAccess
